import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Dropdown,
  Input,
  Checkbox,
  TextArea
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardPostOperationUX = (props: any) => {
    return(
      <div
        id="CardPostOperation"
        style={{ margin: "15px", padding: "20px", backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          style={{ paddingBottom: "0px", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          
          <label
            style={{ fontWeight: "bold", fontSize: "22px" }}>
            {props.languageUX === "en" ? "Operative Note" : "หมายเหตุการปฏิบัติงาน"}
          </label>
          <Button>
            
          </Button>
        </div>
        <hr>
        </hr>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px", fontWeight: "bold" }}>
          
          <div
            style={{ width: "20%", margin: "5px 10px 0px 0px" }}>
            
            <label>
              {props.languageUX === "en" ? "Date of Operation" : "วันที่ดำเนินการ"}
            </label>
            <label
              style={{marginLeft: "20px"}}>
              {props.operatingDetail?.incision_date}
            </label>
          </div>
          <div
            style={{ width: "20%", margin: "5px 10px 0px 0px" }}>
            
            <label>
              {props.languageUX === "en" ? "Operative time" : "เวลาปฏิบัติงาน"}
            </label>
            <label
              style={{marginLeft: "20px"}}>
              {props.operatingDetail?.incision_datetime}
            </label>
          </div>
          <div
            style={{display: "flex", width: "25%", margin: "5px 10px 0px 0px" }}>
            
            <label
              style={{display: "flex", alignItems: "center" }}>
              {props.languageUX === "en" ? "Swab Instrument" : "เครื่องมือเช็ดสำลี"}
            </label>
            <div
              style={{width: "60%", paddingLeft: "20px"}}>
              
              <Dropdown
                fluid={true}
                name="swab_instrument_status"
                onChange={props.onChangeData}
                options={props.swabOptions}
                selection={true}
                value={props.teamDetail?.swab_instrument_status || ""}>
              </Dropdown>
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px", fontWeight: "bold" }}>
          
          <div
            style={{margin: "5px 10px 0px 0px" }}>
            
            <label>
              {props.languageUX === "en" ? "Team" : "ทีม"}
            </label>
            <label
              style={{color: "red"}}>
              *
            </label>
          </div>
          <div
            style={{width: "60%", margin: "5px 10px 0px 0px" }}>
            
            <Dropdown
              fluid={true}
              name="id"
              onChange={props.onChangeTeam}
              options={props.chiefSurgeonOptions}
              selection={true}
              value={props.teamDetail?.id}>
            </Dropdown>
          </div>
        </div>
        <hr>
        </hr>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Assistant Surgeon" : "ผู้ช่วยศัลยแพทย์"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px" }}>
            
            <div>
              {props.teamDetail?.assistant_surgeons_summary}
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Scrub Nurse" : "พยาบาลขัดผิว"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px" }}>
            
            <div>
              {props.teamDetail?.scrub_nurse_summary}
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Circulation Nurse" : "พยาบาลหมุนเวียน"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px" }}>
            
            <div>
              {props.teamDetail?.circulating_nurse_summary}
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Anesthesisologist" : "วิสัญญีแพทย์"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px"}}>
            
            <div>
              {props.teamDetail?.anesthesiologist_summary}
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Anesthetist" : "วิสัญญีแพทย์"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px"}}>
            
            <div>
              {props.teamDetail?.anesthetist_summary}
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Preoperative diagnosis" : "การวินิจฉัยก่อนการผ่าตัด"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", backgroundColor: "rgba(255,255,255)"}}>
            
            <div
              style={{paddingBottom: "5px"}}>
              
              <label
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "Principle Diagnosis" : "หลักการวินิจฉัย"}
              </label>
            </div>
            <div
              style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
              
              <div
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Medical Term" : "ศัพท์ทางการแพทย์"}
                </label>
                <Input
                  fluid={true}
                  name="icd10_med_term"
                  onChange={props.onChangePrePrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd10_med_term || ""}>
                </Input>
              </div>
              <div
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "ICD10 Term" : "คำศัพท์ ICD10"}
                </label>
                <Input
                  fluid={true}
                  name="icd_term"
                  onChange={props.onChangePrePrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd_term || ""}>
                </Input>
              </div>
              <div
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "ICD10 Code" : "รหัส ICD10"}
                </label>
                <Input
                  fluid={true}
                  name="icd_code"
                  onChange={props.onChangePrePrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd_code || ""}>
                </Input>
              </div>
              <div
                style={{ margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <Checkbox
                  checked={props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.active_disease || false}
                  name="active_disease"
                  onChange={props.onChangePreActive}
                  style={{margin: "0px 10px 0 0"}}>
                </Checkbox>
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Active Disease" : "โรคที่กำลังดำเนินอยู่"}
                </label>
                <Button
                  color="teal"
                  icon="erase"
                  size="mini"
                  style={{margin: "0px 10px"}}>
                </Button>
                <Button
                  color="red"
                  icon="minus"
                  size="mini"
                  style={{margin: "0px 0 0 10px"}}>
                </Button>
              </div>
            </div>
            <div
              style={{ display: props.openSearchPrePrincipal ? "block" : "none", zIndex: 100,  width: "calc(100% - 20px)", } }>
              
              <Table
                data={props.searchPostProcedures}
                getTrProps={props.prePrincipleDiagnosis}
                keys="medterm,icdterm,icdcode"
                minRows="4"
                name="test"
                showPagination={false}
                style={{ height: "150px" }}>
              </Table>
            </div>
            <div
              style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
              
              <div
                className="ui form"
                style={{width: "100%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "start" }}>
                
                <div
                  style={{fontWeight: "bold", width: "14%"}}>
                  
                  <label
                    style={{fontWeight: "bold", width: "14%"}}>
                    {props.languageUX === "en" ? "Pre-Diagnosis Detail" : "รายละเอียดก่อนการวินิจฉัย"}
                  </label>
                </div>
                <div
                  style={{width: "65%"}}>
                  
                  <TextArea
                    name="detail.post_op_pre_diagnosis_remark"
                    onChange={props.onChangeData}
                    style={{margin: "0px 10px", width: "100%"}}
                    value={props.teamDetail?.detail?.post_op_pre_diagnosis_remark|| ""}>
                  </TextArea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Postoperative diagnosis" : "การวินิจฉัยหลังการผ่าตัด"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "15px", backgroundColor: "rgba(245,245,245)"}}>
            
            <div
              style={{paddingBottom: "5px"}}>
              
              <label
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "Principle Diagnosis" : "หลักการวินิจฉัย"}
              </label>
              <label
                style={{ color: "red" }}>
                *
              </label>
            </div>
            <div
              style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
              
              <div
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Medical Term" : "ศัพท์ทางการแพทย์"}
                </label>
                <Input
                  fluid={true}
                  name="icd10_med_term"
                  onChange={props.onChangePostPrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_principal_diagnosis[0]?.icd10_med_term || ""}>
                </Input>
              </div>
              <div
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "ICD10 Term" : "คำศัพท์ ICD10"}
                </label>
                <Input
                  fluid={true}
                  name="icd_term"
                  onChange={props.onChangePostPrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_principal_diagnosis[0]?.icd_term || ""}>
                </Input>
              </div>
              <div
                style={{width: "26%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "ICD10 Code" : "รหัส ICD10"}
                </label>
                <Input
                  fluid={true}
                  name="icd_code"
                  onChange={props.onChangePostPrincipal}
                  style={{margin: "0px 10px", width: "100%"}}
                  value={props.teamDetail?.post_principal_diagnosis[0]?.icd_code || ""}>
                </Input>
              </div>
              <div
                style={{margin: "5px 10px 0px 0px", display: "flex", alignItems: "center" }}>
                
                <Checkbox
                  checked={props.teamDetail?.post_principal_diagnosis[0]?.active_disease || false}
                  name="active_disease"
                  onChange={props.onChangePostPrincipal}
                  style={{margin: "0px 10px 0 0"}}>
                </Checkbox>
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Active Disease" : "โรคที่กำลังดำเนินอยู่"}
                </label>
                <Button
                  color="teal"
                  icon="erase"
                  onClick={props.clearPrinciple}
                  size="mini"
                  style={{margin: "0px 10px"}}>
                </Button>
                <Button
                  color="red"
                  icon="minus"
                  onClick={props.clearPrinciple}
                  size="mini"
                  style={{margin: "0px 0 0 10px"}}>
                </Button>
              </div>
            </div>
            <div
              style={{ display: props.openSearchPostPrincipal ? "block" : "none", zIndex: 100,  width: "calc(100% - 20px)", } }>
              
              <Table
                data={props.searchPostProcedures}
                getTrProps={props.postPrincipleDiagnosis}
                keys="medterm,icdterm,icdcode"
                minRows="4"
                showPagination={false}
                style={{ height: "150px" }}>
              </Table>
            </div>
            <div
              style={{...(props.secondary_style || {})}}>
              
              <label
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "Secondary Diagnosis" : "การวินิจฉัยรอง"}
              </label>
            </div>
            <div>
              {props.secondaryDiagnosis}
            </div>
            <div
              style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" , backgroundColor: "rgba(217,217,217)"}}>
              {}
              <Button
                onClick={props.addSecondary}
                style={{width: "100%", height: "100%", padding: "20px"}}>
                {props.languageUX === "en" ? "เพิ่ม Secondary Diagnosis" : "การวินิจฉัยขั้นทุติยภูมิ"}
              </Button>
            </div>
            <div
              style={{width: "100%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "start" }}>
              
              <div
                className="ui form"
                style={{width: "100%", margin: "5px 10px 0px 0px", display: "flex", alignItems: "start" }}>
                
                <div
                  style={{fontWeight: "bold", width: "14%"}}>
                  
                  <label
                    style={{fontWeight: "bold", width: "14%"}}>
                    {props.languageUX === "en" ? "Post-Diagnosis Detail" : "รายละเอียดหลังการวินิจฉัย"}
                  </label>
                </div>
                <div
                  style={{width: "65%"}}>
                  
                  <TextArea
                    name="detail.post_diagnosis_remark"
                    onChange={props.onChangeData}
                    style={{margin: "0px 10px", width: "100%"}}
                    value={props.teamDetail?.detail?.post_diagnosis_remark || ""}>
                  </TextArea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"} }>
            
            <label>
              {props.languageUX === "en" ? "Operation" : "การดำเนินการ"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", backgroundColor: "rgba(245,245,245)"}}>
            
            <div
              style={{margin: "5px 10px 0px 0px", padding: "10px", backgroundColor: "rgba(255,255,255)"}}>
              
              <div
                style={{display: props.hideOperatingTreatment?"none":""}}>
                {props.operationProcedure}
              </div>
              <div
                style={{ display: props.hideOperatingTreatment?"none":"flex", alignItems: "center" ,marginBottom: "15px", backgroundColor: "rgba(217,217,217)"}}>
                
                <Button
                  onClick={props.addProcedure}
                  style={{width: "100%", height: "100%", padding: "20px"}}>
                  {props.languageUX === "en" ? "Add a surgical item" : "เพิ่ม รายการหัตถการ"}
                </Button>
              </div>
              <div
                className="ui form"
                style={{display: "flex", alignItems: "center", marginBottom: "1rem"}}>
                
                <label
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Other detail" : "รายละเอียดอื่น ๆ"}
                </label>
                <TextArea
                  name="post_operating_order_item.other_treatment"
                  onChange={props.onChangeData}
                  rows="5"
                  value={props.teamDetail?.post_operating_order_item?.other_treatment || ""}>
                </TextArea>
              </div>
              <div>
                {props.operation}
              </div>
              <div
                style={{ display: "flex", alignItems: "center" ,marginBottom: "15px", backgroundColor: "rgba(217,217,217)"}}>
                {}
                <Button
                  onClick={props.addOperation}
                  style={{width: "100%", height: "100%", padding: "20px"}}>
                  {props.languageUX === "en" ? "Add Operation" : "เพิ่ม Operation"}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="ui form"
          style={{ display: "flex", alignItems: "start" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "13px 10px 0px 0px", fontWeight: "bold", alignItems: "start"}}>
            
            <label>
              {props.languageUX === "en" ? "Implant" : "การปลูกถ่าย"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "start"}}>
            
            <Checkbox
              checked={props.onImplantCheck}
              label={props.onImplantCheck ? "Yes" : "N/A"}
              name="post_implant.checked"
              onChange={props.onChangeImplantCheck}
              style={{fontWeight: "bold", minWidth: "max-content"}}
              toggle={true}>
            </Checkbox>
            <TextArea
              disabled={!props.onImplantCheck}
              name="post_implant.value"
              onChange={props.onChangeImplantValue}
              rows={7}
              style={{width: "70%", margin: "0px 10px",}}
              value={props.onImplantValue || ""}>
            </TextArea>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Specific Concern" : "ข้อกังวลที่เฉพาะเจาะจง"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <Checkbox
              checked={props.teamDetail?.specific_concern?.checked || false}
              label={props.teamDetail?.specific_concern?.checked ? "Yes" : "N/A"}
              name="specific_concern.checked"
              onChange={props.onChangeData}
              style={{fontWeight: "bold", minWidth: "max-content"}}
              toggle={true}>
            </Checkbox>
            <Input
              disabled={props.teamDetail?.specific_concern?.checked ? false : true}
              name="specific_concern.value"
              onChange={props.onChangeData}
              style={{width: "70%",  margin: "0px 10px",}}
              value={props.teamDetail?.specific_concern?.value || ""}>
            </Input>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Type of wound" : "ประเภทของบาดแผล"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <Dropdown
              name="type_of_wound"
              onChange={props.onChangeData}
              options={props.woundOptions}
              selection={true}
              style={{width: "78%"}}
              value={props.teamDetail?.type_of_wound}>
            </Dropdown>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Specimen" : "ตัวอย่าง"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <div
              style={{display: "flex", alignItems: "center"}}>
              
              <Checkbox
                checked={props.teamDetail?.specimen?.checked || false}
                label={props.teamDetail?.specimen?.checked ? "Yes" : "N/A"}
                name="specimen.checked"
                onChange={props.onChangeData}
                style={{fontWeight: "bold", minWidth: "max-content"}}
                toggle={true}>
              </Checkbox>
            </div>
            <div
              style={{width: "35%", display: "flex", alignItems: "center"}}>
              
              <Checkbox
                checked={props.teamDetail?.specimen?.isCyto || false}
                disabled={props.teamDetail?.specimen?.checked ? false : true}
                label={props.languageUX === "en" ? "CYTO" : "ไซโต"}
                name="specimen.isCyto"
                onChange={props.onChangeData}
                style={{margin: "0px 10px",fontWeight: "bold",minWidth: "max-content"}}>
              </Checkbox>
              <Input
                disabled={!props.teamDetail?.specimen?.isCyto || false}
                fluid={true}
                name="specimen.cyto"
                onChange={props.onChangeData}
                style={{margin: "0px 10px", width: "100%"}}
                value={props.teamDetail?.specimen?.cyto || ""}>
              </Input>
              <label
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "bottle" : "ขวด"}
              </label>
            </div>
            <div
              style={{width: "35%", display: "flex", alignItems: "center"}}>
              
              <Checkbox
                checked={props.teamDetail?.specimen?.isPatho || false}
                disabled={props.teamDetail?.specimen?.checked ? false : true}
                label={props.languageUX === "en" ? "PATHO" : "ปาโธ"}
                name="specimen.isPatho"
                onChange={props.onChangeData}
                style={{margin: "0px 10px",fontWeight: "bold", minWidth: "max-content"}}>
              </Checkbox>
              <Input
                disabled={!props.teamDetail?.specimen?.isPatho || false}
                fluid={true}
                name="specimen.patho"
                onChange={props.onChangeData}
                style={{margin: "0px 10px", width: "100%"}}
                value={props.teamDetail?.specimen?.patho || ""}>
              </Input>
              <label
                style={{fontWeight: "bold"}}>
                {props.languageUX === "en" ? "item" : "ชิ้น"}
              </label>
            </div>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Blood Loss (ml.)" : "ปริมาณเลือดที่เสีย (มล.)"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <Input
              name="blood_loss"
              onChange={props.onChangeData}
              style={{width: "78%"}}
              value={props.teamDetail?.blood_loss}>
            </Input>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Tourniquet" : "สายรัดห้ามเลือด"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <Checkbox
              checked={props.teamDetail?.tourniquet?.checked || false}
              label={props.teamDetail?.tourniquet?.checked ? "Yes" : "N/A"}
              name="tourniquet.checked"
              onChange={props.onChangeData}
              toggle={true}>
            </Checkbox>
            <Input
              disabled={props.teamDetail?.tourniquet?.checked ? false : true}
              name="tourniquet.value"
              onChange={props.onChangeData}
              style={{width: "70%", margin: "0px 10px",}}
              value={props.teamDetail?.tourniquet?.value || ""}>
            </Input>
          </div>
        </div>
        <div
          className="ui form"
          style={{ display: "flex", alignItems: "baseline" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Operative Findings" : "ผลการตรวจทางห้องปฏิบัติการ"}
            </label>
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <TextArea
              name="detail.operative_findings"
              onChange={props.onChangeData}
              rows="5"
              style={{width: "100%", padding: "10px", resize: "none"}}
              value={props.teamDetail?.detail?.operative_findings || ""}>
            </TextArea>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" ,padding: "5px 10px 0px 0px",margin: "5px 10px 0px 0px"}}>
          
          <Button
            color="teal"
            onClick={props.openTemplate}
            style={{backgroundColor: "rgba(19,128,88)"}}>
            {props.languageUX === "en" ? "Template" : "เทมเพลต"}
          </Button>
        </div>
        <div
          style={{ display: "flex", alignItems: "baseline" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Procedure" : "ขั้นตอน"}
            </label>
          </div>
          <div
            className="ui form"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <TextArea
              name="operative_note"
              onChange={props.onChangeData}
              rows="10"
              style={{width: "100%", padding: "10px", resize: "none"}}
              value={props.teamDetail?.operative_note}>
            </TextArea>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "baseline" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", minWidth: "120px", maxWidth: "120px",margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
            <label>
              {props.languageUX === "en" ? "Complication" : "ภาวะแทรกซ้อน"}
            </label>
          </div>
          <div
            className="ui form"
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center"}}>
            
            <TextArea
              name="detail.operative_complication"
              onChange={props.onChangeData}
              rows="10"
              style={{width: "100%", padding: "10px", resize: "none"}}
              value={props.teamDetail?.detail?.operative_complication || ""}>
            </TextArea>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center" ,paddingBottom: "5px"}}>
          
          <div
            style={{display: "flex", justifyContent: "flex-end", width: "10%", margin: "5px 10px 0px 0px", fontWeight: "bold"}}>
            
          </div>
          <div
            style={{width: "90%", margin: "5px 10px 0px 0px", padding: "10px", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
            
            <div>
              
            </div>
            <div>
              {props.onPrint}
            </div>
          </div>
        </div>
        <div
          style={{padding: "20px", backgroundColor: "rgba(245,245,245)", margin: "5px 10px 0px 0px"}}>
          
          <div>
            
            <label
              style={{fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Surgical illustration" : "ภาพประกอบการผ่าตัด"}
            </label>
          </div>
          <div
            style={{padding: "10px 0px"}}>
            {props.imgDetail}
          </div>
          <div>
            
            <Button
              color="blue"
              disabled={props.disabledUpload}
              onClick={props.takePhoto}
              style={{marginRight: "10px" }}>
              {props.languageUX === "en" ? "Take Photo" : "ถ่ายรูป"}
            </Button>
            <Button
              color="blue"
              disabled={props.disabledUpload}
              onClick={props.uploadImg}>
              {props.languageUX === "en" ? "Upload" : "อัพโหลด"}
            </Button>
          </div>
        </div>
        <div
          style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" ,padding: "5px 10px 0px 0px",margin: "15px 10px 0px 0px"}}>
          
          <div>
            {props.buttonSave}
          </div>
          <div
            style={{margin: "0px 5px" ,display: "none"}}>
            
            <Button
              color="green">
              {props.languageUX === "en" ? "Confirm" : "ยืนยัน"}
            </Button>
          </div>
          <div
            style={{display: "none"}}>
            
            <Button
              color="red">
              {props.languageUX === "en" ? "Unconfirm" : "ยกเลิกการยืนยัน"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardPostOperationUX

export const screenPropsDefault = {"debug":true,"showSupplyList":false}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostOperation"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\", padding: \"20px\", backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"0px\", display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุการปฏิบัติงาน",
          "valueEN": "Operative Note"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"22px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": ""
        },
        "size": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "hr",
      "parent": 0,
      "props": {
      },
      "seq": 5,
      "void": true
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\", fontWeight: \"bold\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", width: \"25%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"20%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ดำเนินการ",
          "valueEN": "Date of Operation"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.operatingDetail?.incision_date"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"20%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาปฏิบัติงาน",
          "valueEN": "Operative time"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "props.operatingDetail?.incision_datetime"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"60%\", paddingLeft: \"20px\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Dropdown",
      "parent": 21,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "swab_instrument_status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.swabOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.swab_instrument_status || \"\""
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "เครื่องมือเช็ดสำลี",
          "valueEN": "Swab Instrument"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\", fontWeight: \"bold\" }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"60%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "ทีม",
          "valueEN": "Team"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Dropdown",
      "parent": 28,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeTeam"
        },
        "options": {
          "type": "code",
          "value": "props.chiefSurgeonOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.id"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "hr",
      "parent": 0,
      "props": {
      },
      "seq": 32,
      "void": true
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ช่วยศัลยแพทย์",
          "valueEN": "Assistant Surgeon"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "code",
          "value": "props.teamDetail?.assistant_surgeons_summary"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "props.teamDetail?.scrub_nurse_summary"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาลขัดผิว",
          "valueEN": "Scrub Nurse"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 48,
      "props": {
        "children": {
          "type": "code",
          "value": "props.teamDetail?.circulating_nurse_summary"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาลหมุนเวียน",
          "valueEN": "Circulation Nurse"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "code",
          "value": "props.teamDetail?.anesthesiologist_summary"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "วิสัญญีแพทย์",
          "valueEN": "Anesthesisologist"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "code",
          "value": "props.teamDetail?.anesthetist_summary"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "label",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "วิสัญญีแพทย์",
          "valueEN": "Anesthetist"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", backgroundColor: \"rgba(255,255,255)\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "label",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยก่อนการผ่าตัด",
          "valueEN": "Preoperative diagnosis"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: \"5px\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "หลักการวินิจฉัย",
          "valueEN": "Principle Diagnosis"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "ศัพท์ทางการแพทย์",
          "valueEN": "Medical Term"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "label",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "คำศัพท์ ICD10",
          "valueEN": "ICD10 Term"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "label",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัส ICD10",
          "valueEN": "ICD10 Code"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "label",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "โรคที่กำลังดำเนินอยู่",
          "valueEN": "Active Disease"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "Input",
      "parent": 69,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "icd10_med_term"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePrePrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd10_med_term || \"\""
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Input",
      "parent": 70,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "icd_term"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePrePrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd_term || \"\""
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "Input",
      "parent": 71,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "icd_code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePrePrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.icd_code || \"\""
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "Checkbox",
      "parent": 72,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.post_op_pre_principal_diagnosis?.[0]?.active_disease || false"
        },
        "name": {
          "type": "value",
          "value": "active_disease"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePreActive"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px 0 0\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Button",
      "parent": 72,
      "props": {
        "color": {
          "type": "value",
          "value": "teal"
        },
        "icon": {
          "type": "value",
          "value": "erase"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Button",
      "parent": 72,
      "props": {
        "color": {
          "type": "value",
          "value": "red"
        },
        "icon": {
          "type": "value",
          "value": "minus"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 0 0 10px\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"start\" }"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"65%\"}"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"15px\", backgroundColor: \"rgba(245,245,245)\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: \"5px\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"center\", width: \"100%\", height: \"100%\" , backgroundColor: \"rgba(217,217,217)\"}"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยหลังการผ่าตัด",
          "valueEN": "Postoperative diagnosis"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "label",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": "หลักการวินิจฉัย",
          "valueEN": "Principle Diagnosis"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"26%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "label",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": "ศัพท์ทางการแพทย์",
          "valueEN": "Medical Term"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "label",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "คำศัพท์ ICD10",
          "valueEN": "ICD10 Term"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "label",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัส ICD10",
          "valueEN": "ICD10 Code"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "โรคที่กำลังดำเนินอยู่",
          "valueEN": "Active Disease"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "Input",
      "parent": 100,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "icd10_med_term"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePostPrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_principal_diagnosis[0]?.icd10_med_term || \"\""
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "Input",
      "parent": 101,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "icd_term"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePostPrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_principal_diagnosis[0]?.icd_term || \"\""
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Input",
      "parent": 102,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "icd_code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePostPrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_principal_diagnosis[0]?.icd_code || \"\""
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Checkbox",
      "parent": 103,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.post_principal_diagnosis[0]?.active_disease || false"
        },
        "label": {
          "type": "code",
          "value": ""
        },
        "name": {
          "type": "value",
          "value": "active_disease"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePostPrincipal"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px 0 0\"}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Button",
      "parent": 103,
      "props": {
        "color": {
          "type": "value",
          "value": "teal"
        },
        "icon": {
          "type": "value",
          "value": "erase"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearPrinciple"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Button",
      "parent": 103,
      "props": {
        "color": {
          "type": "value",
          "value": "red"
        },
        "icon": {
          "type": "value",
          "value": "minus"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearPrinciple"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 0 0 10px\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"} "
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "label",
      "parent": 115,
      "props": {
        "children": {
          "type": "value",
          "value": "การดำเนินการ",
          "valueEN": "Operation"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", backgroundColor: \"rgba(245,245,245)\"}"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px 10px 0px 0px\", padding: \"10px\", backgroundColor: \"rgba(255,255,255)\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideOperatingTreatment?\"none\":\"flex\", alignItems: \"center\" ,marginBottom: \"15px\", backgroundColor: \"rgba(217,217,217)\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,marginBottom: \"15px\", backgroundColor: \"rgba(217,217,217)\"}"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"start\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"13px 10px 0px 0px\", fontWeight: \"bold\", alignItems: \"start\"}"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"start\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "label",
      "parent": 153,
      "props": {
        "children": {
          "type": "value",
          "value": "การปลูกถ่าย",
          "valueEN": "Implant"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "Checkbox",
      "parent": 154,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.onImplantCheck"
        },
        "label": {
          "type": "code",
          "value": "props.onImplantCheck ? \"Yes\" : \"N/A\""
        },
        "name": {
          "type": "value",
          "value": "post_implant.checked"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeImplantCheck"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "label",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อกังวลที่เฉพาะเจาะจง",
          "valueEN": "Specific Concern"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "Checkbox",
      "parent": 160,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.specific_concern?.checked || false"
        },
        "label": {
          "type": "code",
          "value": "props.teamDetail?.specific_concern?.checked ? \"Yes\" : \"N/A\""
        },
        "name": {
          "type": "value",
          "value": "specific_concern.checked"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "Input",
      "parent": 160,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.teamDetail?.specific_concern?.checked ? false : true"
        },
        "name": {
          "type": "value",
          "value": "specific_concern.value"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70%\",  margin: \"0px 10px\",}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.specific_concern?.value || \"\""
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "div",
      "parent": 166,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "div",
      "parent": 166,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "label",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทของบาดแผล",
          "valueEN": "Type of wound"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "label",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": "ตัวอย่าง",
          "valueEN": "Specimen"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"35%\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"35%\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "Checkbox",
      "parent": 175,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.checked || false"
        },
        "label": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.checked ? \"Yes\" : \"N/A\""
        },
        "name": {
          "type": "value",
          "value": "specimen.checked"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "label",
      "parent": 176,
      "props": {
        "children": {
          "type": "value",
          "value": "ขวด",
          "valueEN": "bottle"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "Input",
      "parent": 176,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.teamDetail?.specimen?.isCyto || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "specimen.cyto"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.cyto || \"\""
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 183,
      "name": "Checkbox",
      "parent": 177,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.isPatho || false"
        },
        "disabled": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.checked ? false : true"
        },
        "label": {
          "type": "value",
          "value": "ปาโธ",
          "valueEN": "PATHO"
        },
        "name": {
          "type": "value",
          "value": "specimen.isPatho"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\",fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "label",
      "parent": 177,
      "props": {
        "children": {
          "type": "value",
          "value": "ชิ้น",
          "valueEN": "item"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "Input",
      "parent": 177,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.teamDetail?.specimen?.isPatho || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "specimen.patho"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.patho || \"\""
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 187,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "div",
      "parent": 187,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 187,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "label",
      "parent": 188,
      "props": {
        "children": {
          "type": "value",
          "value": "ปริมาณเลือดที่เสีย (มล.)",
          "valueEN": "Blood Loss (ml.)"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "Input",
      "parent": 189,
      "props": {
        "name": {
          "type": "value",
          "value": "blood_loss"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width: \"78%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.blood_loss"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 193,
      "name": "div",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "div",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "label",
      "parent": 193,
      "props": {
        "children": {
          "type": "value",
          "value": "สายรัดห้ามเลือด",
          "valueEN": "Tourniquet"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "Checkbox",
      "parent": 194,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.tourniquet?.checked || false"
        },
        "label": {
          "type": "code",
          "value": "props.teamDetail?.tourniquet?.checked ? \"Yes\" : \"N/A\""
        },
        "name": {
          "type": "value",
          "value": "tourniquet.checked"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 198,
      "name": "Input",
      "parent": 194,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.teamDetail?.tourniquet?.checked ? false : true"
        },
        "name": {
          "type": "value",
          "value": "tourniquet.value"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70%\", margin: \"0px 10px\",}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.tourniquet?.value || \"\""
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": null,
      "id": 199,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"flex-end\" ,padding: \"5px 10px 0px 0px\",margin: \"5px 10px 0px 0px\"}"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": null,
      "id": 200,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"baseline\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": null,
      "id": 201,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 202,
      "name": "Button",
      "parent": 199,
      "props": {
        "children": {
          "type": "value",
          "value": "เทมเพลต",
          "valueEN": "Template"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "onClick": {
          "type": "code",
          "value": "props.openTemplate"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(19,128,88)\"}"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": null,
      "id": 203,
      "name": "div",
      "parent": 200,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": null,
      "id": 204,
      "name": "div",
      "parent": 200,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": null,
      "id": 205,
      "name": "label",
      "parent": 203,
      "props": {
        "children": {
          "type": "value",
          "value": "ขั้นตอน",
          "valueEN": "Procedure"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 207,
      "name": "TextArea",
      "parent": 204,
      "props": {
        "disabled": {
          "type": "value",
          "value": ""
        },
        "name": {
          "type": "value",
          "value": "operative_note"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "10"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding: \"10px\", resize: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.operative_note"
        }
      },
      "seq": 207,
      "void": true
    },
    {
      "from": null,
      "id": 208,
      "name": "div",
      "parent": 201,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", width: \"10%\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": null,
      "id": 209,
      "name": "div",
      "parent": 201,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": null,
      "id": 212,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"20px\", backgroundColor: \"rgba(245,245,245)\", margin: \"5px 10px 0px 0px\"}"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": null,
      "id": 213,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"flex-end\" ,padding: \"5px 10px 0px 0px\",margin: \"15px 10px 0px 0px\"}"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": null,
      "id": 214,
      "name": "div",
      "parent": 212,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "div",
      "parent": 212,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 216,
      "name": "label",
      "parent": 214,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาพประกอบการผ่าตัด",
          "valueEN": "Surgical illustration"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 217,
      "name": "Button",
      "parent": 215,
      "props": {
        "children": {
          "type": "value",
          "value": "ถ่ายรูป",
          "valueEN": "Take Photo"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledUpload"
        },
        "onClick": {
          "type": "code",
          "value": "props.takePhoto"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 218,
      "name": "Button",
      "parent": 215,
      "props": {
        "children": {
          "type": "value",
          "value": "อัพโหลด",
          "valueEN": "Upload"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledUpload"
        },
        "onClick": {
          "type": "code",
          "value": "props.uploadImg"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 222,
      "name": "Dropdown",
      "parent": 168,
      "props": {
        "name": {
          "type": "value",
          "value": "type_of_wound"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.woundOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"78%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.type_of_wound"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": null,
      "id": 223,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{...(props.secondary_style || {})}"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": null,
      "id": 224,
      "name": "label",
      "parent": 223,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยรอง",
          "valueEN": "Secondary Diagnosis"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 224,
      "void": false
    },
    {
      "from": null,
      "id": 225,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "code",
          "value": "props.secondaryDiagnosis"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 226,
      "name": "Button",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัยขั้นทุติยภูมิ",
          "valueEN": "เพิ่ม Secondary Diagnosis"
        },
        "onClick": {
          "type": "code",
          "value": "props.addSecondary"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", padding: \"20px\"}"
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 227,
      "name": "Checkbox",
      "parent": 176,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.isCyto || false"
        },
        "disabled": {
          "type": "code",
          "value": "props.teamDetail?.specimen?.checked ? false : true"
        },
        "label": {
          "type": "value",
          "value": "ไซโต",
          "valueEN": "CYTO"
        },
        "name": {
          "type": "value",
          "value": "specimen.isCyto"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\",fontWeight: \"bold\",minWidth: \"max-content\"}"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 228,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": "props.operationProcedure"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideOperatingTreatment?\"none\":\"\"}"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 229,
      "name": "Button",
      "parent": 126,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม รายการหัตถการ",
          "valueEN": "Add a surgical item"
        },
        "onClick": {
          "type": "code",
          "value": "props.addProcedure"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", padding: \"20px\"}"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": null,
      "id": 230,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": "props.operation"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 231,
      "name": "Button",
      "parent": 129,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม Operation",
          "valueEN": "Add Operation"
        },
        "onClick": {
          "type": "code",
          "value": "props.addOperation"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", padding: \"20px\"}"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": null,
      "id": 233,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: props.openSearchPostPrincipal ? \"block\" : \"none\", zIndex: 100,  width: \"calc(100% - 20px)\", } "
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 234,
      "name": "Table",
      "parent": 233,
      "props": {
        "data": {
          "type": "code",
          "value": "props.searchPostProcedures"
        },
        "defaultPageSize": {
          "type": "code",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": "props.postPrincipleDiagnosis"
        },
        "keys": {
          "type": "value",
          "value": "medterm,icdterm,icdcode"
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"150px\" }"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": null,
      "id": 235,
      "name": "div",
      "parent": 213,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": null,
      "id": 236,
      "name": "div",
      "parent": 213,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 5px\" ,display: \"none\"}"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": null,
      "id": 237,
      "name": "div",
      "parent": 213,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 239,
      "name": "Button",
      "parent": 236,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยัน",
          "valueEN": "Confirm"
        },
        "color": {
          "type": "value",
          "value": "green"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 240,
      "name": "Button",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกการยืนยัน",
          "valueEN": "Unconfirm"
        },
        "color": {
          "type": "value",
          "value": "red"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": null,
      "id": 241,
      "name": "div",
      "parent": 212,
      "props": {
        "children": {
          "type": "code",
          "value": "props.imgDetail"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 0px\"}"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": null,
      "id": 242,
      "name": "div",
      "parent": 209,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": null,
      "id": 243,
      "name": "div",
      "parent": 209,
      "props": {
        "children": {
          "type": "code",
          "value": "props.onPrint"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": null,
      "id": 244,
      "name": "label",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 245,
      "name": "TextArea",
      "parent": 90,
      "props": {
        "name": {
          "type": "value",
          "value": "detail.post_op_pre_diagnosis_remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.detail?.post_op_pre_diagnosis_remark|| \"\""
        }
      },
      "seq": 245,
      "void": true
    },
    {
      "from": null,
      "id": 246,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", width: \"14%\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 247,
      "name": "label",
      "parent": 246,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดก่อนการวินิจฉัย",
          "valueEN": "Pre-Diagnosis Detail"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", width: \"14%\"}"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 248,
      "name": "TextArea",
      "parent": 154,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.onImplantCheck"
        },
        "name": {
          "type": "value",
          "value": "post_implant.value"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeImplantValue"
        },
        "readOnly": {
          "type": "code",
          "value": ""
        },
        "rows": {
          "type": "code",
          "value": "7"
        },
        "style": {
          "type": "code",
          "value": "{width: \"70%\", margin: \"0px 10px\",}"
        },
        "value": {
          "type": "code",
          "value": "props.onImplantValue || \"\""
        }
      },
      "seq": 248,
      "void": true
    },
    {
      "from": null,
      "id": 249,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"start\" }"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": null,
      "id": 250,
      "name": "div",
      "parent": 249,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", margin: \"5px 10px 0px 0px\", display: \"flex\", alignItems: \"start\" }"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 250,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", width: \"14%\"}"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "div",
      "parent": 250,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"65%\"}"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "label",
      "parent": 251,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดหลังการวินิจฉัย",
          "valueEN": "Post-Diagnosis Detail"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", width: \"14%\"}"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 254,
      "name": "TextArea",
      "parent": 252,
      "props": {
        "name": {
          "type": "value",
          "value": "detail.post_diagnosis_remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\", width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.detail?.post_diagnosis_remark || \"\""
        }
      },
      "seq": 254,
      "void": true
    },
    {
      "from": null,
      "id": 255,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginBottom: \"1rem\"}"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 256,
      "name": "label",
      "parent": 255,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดอื่น ๆ",
          "valueEN": "Other detail"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 257,
      "name": "TextArea",
      "parent": 255,
      "props": {
        "name": {
          "type": "value",
          "value": "post_operating_order_item.other_treatment"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "5"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.post_operating_order_item?.other_treatment || \"\""
        }
      },
      "seq": 257,
      "void": true
    },
    {
      "from": null,
      "id": 258,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: props.openSearchPrePrincipal ? \"block\" : \"none\", zIndex: 100,  width: \"calc(100% - 20px)\", } "
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 259,
      "name": "Table",
      "parent": 258,
      "props": {
        "data": {
          "type": "code",
          "value": "props.searchPostProcedures"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.prePrincipleDiagnosis"
        },
        "keys": {
          "type": "value",
          "value": "medterm,icdterm,icdcode"
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "name": {
          "type": "value",
          "value": "test"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"150px\" }"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": null,
      "id": 260,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"baseline\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": null,
      "id": 261,
      "name": "div",
      "parent": 260,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\", margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 262,
      "name": "div",
      "parent": 260,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": null,
      "id": 263,
      "name": "label",
      "parent": 261,
      "props": {
        "children": {
          "type": "value",
          "value": "ผลการตรวจทางห้องปฏิบัติการ",
          "valueEN": "Operative Findings"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 264,
      "name": "TextArea",
      "parent": 262,
      "props": {
        "name": {
          "type": "value",
          "value": "detail.operative_findings"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "5"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding: \"10px\", resize: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.detail?.operative_findings || \"\""
        }
      },
      "seq": 264,
      "void": true
    },
    {
      "from": null,
      "id": 265,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"baseline\" ,paddingBottom: \"5px\"}"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": null,
      "id": 266,
      "name": "div",
      "parent": 265,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", minWidth: \"120px\", maxWidth: \"120px\",margin: \"5px 10px 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": null,
      "id": 267,
      "name": "div",
      "parent": 265,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "style": {
          "type": "code",
          "value": "{width: \"90%\", margin: \"5px 10px 0px 0px\", padding: \"10px\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": null,
      "id": 268,
      "name": "label",
      "parent": 266,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาวะแทรกซ้อน",
          "valueEN": "Complication"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 269,
      "name": "TextArea",
      "parent": 267,
      "props": {
        "name": {
          "type": "value",
          "value": "detail.operative_complication"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "10"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding: \"10px\", resize: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.teamDetail?.detail?.operative_complication || \"\""
        }
      },
      "seq": 269,
      "void": true
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": false,
  "name": "CardPostOperationUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "debug": true,
    "showSupplyList": false
  },
  "width": 75
}

*********************************************************************************** */
